import React, { useState } from 'react';
import SurveysListPage from './SurveysListPage';
import SurveyDashboardPage from './SurveyDashboardPage';
import SettingNumber from '../SettingNumber';
import { API_BASE_URL } from '../../config/api';

const SurveysView: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'surveys' | 'results' | 'settings'>('surveys');

  return (
    <div className="container-fluid mt-3 mb-5">
      <div className="mb-3">
        <h2 className="mb-1">Surveys</h2>
        <div className="text-muted">In-app surveys shown to users in the mobile app.</div>
      </div>
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button
            type="button"
            className={`nav-link${activeTab === 'surveys' ? ' active' : ''}`}
            onClick={() => setActiveTab('surveys')}
          >
            Surveys
          </button>
        </li>
        <li className="nav-item">
          <button
            type="button"
            className={`nav-link${activeTab === 'results' ? ' active' : ''}`}
            onClick={() => setActiveTab('results')}
          >
            Results
          </button>
        </li>
        <li className="nav-item">
          <button
            type="button"
            className={`nav-link${activeTab === 'settings' ? ' active' : ''}`}
            onClick={() => setActiveTab('settings')}
          >
            Settings
          </button>
        </li>
      </ul>

      {activeTab === 'surveys' && <SurveysListPage />}
      {activeTab === 'results' && <SurveyDashboardPage />}
      {activeTab === 'settings' && (
        <div className="card border-0 shadow-sm">
          <div className="card-body d-flex flex-column gap-3">
            <h5 className="card-title">Survey Settings</h5>
            <div className="rounded-3 bg-light border p-3">
              <SettingNumber
                apiBaseUrl={API_BASE_URL}
                settingKey="survey_min_days_between_surveys"
                title="Minimum days between surveys"
                description="After a user completes or opts out of a survey, wait this many days before offering another survey. Set to 0 to allow the next eligible survey immediately."
                defaultValue={0}
                min={0}
                saveDescription="Minimum days to wait before offering another survey"
                suffix={<span className="text-muted small">days</span>}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SurveysView;
